var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sp-landing-textblock text-block",style:({ justifyContent: _vm.data.style && _vm.data.style.justifyContent })},[(_vm.isPlainText)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.filterText)}}):_c('div',{ref:"shadow"})])}
var staticRenderFns = []

export { render, staticRenderFns }